<template>
	<div class="col-xs-12 dynvibeStory">
		<div class="col-xs-12 col-lg-12">
			<div v-if="middle" class="col-lg-1 col-xs-12">
				<input
					class="dynvibeStoryCheckbox"
					name="dynvibeStoryCheckbox"
					type="checkbox"
					v-bind:value="post.url"
					@change="$emit('listcheckedmt', { event: $event.target.checked, mastertag: post.mastertags, storieschecked: post_id })"
					:checked="checkedallstories"
				/>
				<span
					v-if="editrule"
					:id="'buttonify_' + post_id"
					@click="$emit('buttonify', { id: post_id })"
					class="glyphicon glyphicon-pencil buttonify dynvibeCreateRule"
					style="cursor: pointer; margin-left: 10px; margin-top: 20px"
				></span>
			</div>
			<div class="col-lg-2 col-xs-12 dynvibeStoryInfo">
				<span style="display: inline-block">
					<span class="dynvibeStoryInfoDate">{{ getDate(post.post_date, "date") }}</span>
					<span class="dynvibeStoryInfoHour">{{ getDate(post.post_date, "time") }}</span>
				</span>
				<a v-bind:href="post.post_url" target="_blank">
					<i class="fab" v-bind:class="'fa-' + post.post_media"></i>
				</a>
			</div>
			<div v-if="middle" class="col-lg-1 col-xs-12 dynvibeStoryInfo">
				<img class="dynvibeArrayTopImg" v-bind:src="post.source[0].profile_pic" width="60" height="60" />
			</div>
			<div v-if="middle">
				<span class="dynvibeStoryInfoUsername">
					<span
						data-action="Edit"
						data-value="post.profile_id"
						class="dynvibeTableActions dynvibeTableActionsEdit dynvibeModalAuthor"
						title="Edit"
						@click="editProfile(post.profile_id)"
						>{{ post.profile_name }}</span
					>
				</span>
			</div>

			<div v-if="post.profile_id" class="col-lg-9 col-xs-12 pull-right dynvibeSegmentsInfo" style="margin-top: 20px">
				<div class="col-lg-10">
					<div class="dynvibePostSegment" v-for="segment in post.profile_segments" v-bind:key="segment">
						{{ segment }}
					</div>
				</div>

				<div class="col-lg-1" v-if="!middle">
					<highlight :idpost="post_id" :prop-active="getHighlight(post)" :ref="'highlight-' + post_id"></highlight>
				</div>
			</div>
		</div>
		<div class="col-xs-12 col-lg-12" style="margin-top: 20px">
			<div class="col-lg-2 col-xs-12 dynvibeStoryImg">
				<a
					:href="post.post_url"
					target="_blank"
					class="postPicture_big"
					v-bind:style="{
						backgroundImage:
							'url(' +
							post.post_picture +
							'),url(' +
							picture_host +
							post.profile_id +
							'/source/' +
							post.post_url.split('/')[4] +
							'.jpg' +
							')',
					}"
				></a>
				<fiche v-if="showfiche" :idprofile="post.profile_id" :middle="middle"></fiche>
			</div>
			<div class="col-lg-8 col-xs-12">
				<div class="row dynvibeStoryContenu">
					<p>
						<span class="dynvibeToTranslateResult" v-html="postTitle"></span>
						<span class="dynvibeToTranslateResult" v-html="postDescription"></span>
						<button class="dynvibeTranslate dynvibeButton" @click="translatePost()">Translate</button>
						<span v-if="loadingTranslate" class="dynvibeLoading" style="min-height: 0px"></span>
						<span v-if="translateResult" class="translateResult">
							{{ translateResult }}
						</span>
					</p>
				</div>
				<div class="row">
					<div class="dynvibePostMastertag dynvibeNeutral" v-for="mastertag in post.mastertags" v-bind:key="mastertag.label">
						{{ mastertag.label }}
					</div>

					<div class="dynvibeStoryStats">
						<span title="likes" alt="likes"><span class="far fa-thumbs-up"></span> {{ post.post_likes }}</span>
						<span v-if="post.post_media === 'instagram'" title="comments" alt="comments"
							><span class="far fa-comment"></span> {{ post.post_comments }}
						</span>
						<span v-if="post.post_media === 'twitter'" title="shares" alt="shares"
							><span class="fas fa-retweet"></span>{{ post.post_shares || "0" }}
						</span>

						<span
							class="dynvibeStoryScore"
							title="Dynvibe Impact score is: ?&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (? followers) Content: ? shares, ? favorites"
							alt="Dynvibe Impact score is: ?&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (? followers) Content: ? shares, ? favorites"
						>
							{{ post.post_impact_score || "0" }}
						</span>
					</div>
				</div>
			</div>

			<div v-if="middle" class="col-lg-2 col-xs-12 pull-right dynvibeStoryInfo">
				<span style="display: block">
					<a
						v-for="source in post.source"
						v-bind:key="source.media"
						class="dynvibeProfilesLinkPosts"
						v-bind:href="'https://' + source.media + '.com/' + source.username"
						target="_blank"
						>({{ source.media }}) {{ source.username }}</a
					>
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import storyMixin from "@/mixins/storyMixin.js";
// import mixin from "@/mixins/mixin.js";
import fiche from "@/components/posts/fiche.vue";
import highlight from "@/components/highlight/highlight.vue";
//import confirm from "@components/globalVue/Confirm.vue";

export default {
	name: "bigstory",
	mixins: [storyMixin],
	inject: ["picture_host"],
	props: {
		checkedallstories: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			showModalRules: false,
			//mastertags:"",
			group1: "",
			group2: "",
			textToButton: [],
			rowSynonym1: [],
			rowSynonym2: [],
			showSyn1: false,
			showSyn2: false,
			listCheckedMt: [],
			story_is_checked: false,
			selectedMt: "",
			firstSyn1: "",
			firstSyn2: "",
			confirmColor: "",
			confirmTitle: "",
			confirmType: "",
			confirmMessage: "",
			inputConfirm: false,
			confirmAdd: "",
			syn1Showed: false,
			syn2Showed: false,
			idprofile: "",
		};
	},
	watch: {
		checkedallstories(newVal) {
			this.$emit("listcheckedmt", {
				event: newVal,
				mastertag: this.post.mastertags,
				storieschecked: this.post.post_id,
			});
		},
	},
	components: {
		//confirm: confirm,
		fiche: fiche,
		highlight: highlight,
	},
	methods: {
		editProfile(idprofile) {
			this.idprofile = idprofile;
			this.$emit("editprofile", this.idprofile);
		},
	},
};
</script>

<style scoped>
.postPicture_big {
	width: 200px;
	height: 200px;
	max-width: 100%;
	display: block;
	background-position: center;
	background-size: cover;
}

.translateResult {
	display: block;
	margin-bottom: 10px;
}

.translateResult {
	padding: 10px;
	border: 1px dashed #33d1cd;
	min-height: 60px;
}

.highlightInclude {
	white-space: pre-wrap;
}

.dynvibeStoryStats {
	display: flex;
	align-items: center;
	height: 35px;
	float: right;
	font-size: 18px;
	color: #9d9d9d;
}
.dynvibeStoryStats > span {
	margin-left: 15px;
}

.dynvibeStoryStats > span > span {
	margin-right: 3px;
}

.dynvibeStoryScore {
	font-size: 26px;
	min-width: 50px;
	text-align: right;
}
</style>
